exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".version[data-v-6efe4612]{position:absolute;bottom:0}", "", {"version":3,"sources":["D:/a/1/s/src/components/src/components/index.vue"],"names":[],"mappings":"AAoBA,0BACA,kBAAA,AACA,QAAA,CACA","file":"index.vue","sourcesContent":["<template>\r\n    <div>\r\n        <p class=\"version\">v1.0.0.0818.0</p>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'index',\r\n  data () {\r\n    return {\r\n    }\r\n  },\r\n  mounted(){\r\n\r\n  }\r\n}\r\n</script>\r\n\r\n<style scoped>\r\n.version{\r\n    position: absolute;\r\n    bottom: 0;\r\n}\r\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6efe4612","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index.vue
// module id = xKOX
// module chunks = 1